/**
 * テナント管理者（owner/admin）のみアクセス可能なルートを保護するコンポーネント
 */
import { type FC, type ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../hooks/authProvider/authProvider";
import { isTenantAdmin } from "../utils/authority-utils";

type TenantAdminRouteProps = {
  children: ReactNode;
};

export const TenantAdminRoute: FC<TenantAdminRouteProps> = ({ children }) => {
  const { currentUser, isLoadingUser } = useContext(AuthContext);

  // ローディング中
  if (isLoadingUser) {
    return (
      <div className="flex justify-center items-center min-h-[50vh]">
        <span className="loading loading-spinner loading-lg" />
      </div>
    );
  }

  // ユーザーがログインしていない
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // テナント管理者でない場合はホームへリダイレクト
  if (!isTenantAdmin(currentUser)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default TenantAdminRoute;
